function normalizeConfiguredUrl(rawValue) {
  const value = String(rawValue || "").trim();
  if (!value) return null;

  try {
    const normalized =
      typeof window !== "undefined"
        ? new URL(value, window.location.origin)
        : new URL(value);

    if (!["http:", "https:"].includes(normalized.protocol)) {
      return null;
    }

    return normalized.toString();
  } catch {
    return null;
  }
}

export function resolveAndroidApkUrl() {
  return normalizeConfiguredUrl(process.env.REACT_APP_ANDROID_APK_URL);
}

export function getAndroidApkDownloadMeta() {
  const url = resolveAndroidApkUrl();

  return {
    url,
    isConfigured: Boolean(url),
    label: process.env.REACT_APP_ANDROID_APK_LABEL?.trim() || "Download APK",
  };
}
